import {readStore, writeStore} from "@/js/utilities/storage.js";
import {signal} from "@preact/signals-react";

const names = ["YI", "Complay"]

let name = readStore("name", 0);

export const $appName = signal(names[name])

export const nextName = () => {
    console.log("nextName")
    name = (name + 1) % names.length
    writeStore("name", name)
    $appName.value = names[name]
}